import React, { useState, useEffect, useCallback } from 'react';

import { Table, Button, Space, Input, Row, Col, Modal, Form, Select, message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { otherApi } from '../api';

const Member = () => {
  const [searchText, setSearchText] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [vakairaOptions, setVakairaOptions] = useState([]);
  const [subVakairaOptions, setSubVakairaOptions] = useState([]);
  const [selectedVakaira, setSelectedVakaira] = useState(null);
  const [vakairaMap, setVakairaMap] = useState(new Map());
  const [subVakairaMap, setSubVakairaMap] = useState(new Map());
  const [familyType, setFamilyType] = useState('');
  const [additionalInfoOptions, setAdditionalInfoOptions] = useState([]);
  const [selectedSubVakaira, setSelectedSubVakaira] = useState(null);

  const fetchFamilyHeads = useCallback(async (vakairaId, subVakairaId) => {
    try {
      const vakairaName = vakairaMap.get(vakairaId) || 'Unknown Vakaira';
      const subVakairaName = subVakairaMap.get(subVakairaId) || 'Unknown Sub-Vakaira';

      const response = await otherApi.get('/member/get-all-maleheadMember', {
        params: {
          vakairaName,
          subVakairaName
        }
      });

      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        setAdditionalInfoOptions(response.data.data.map(fh => ({
          value: fh._id,
          label: fh.memberName || 'Unknown'
        })));
      } else {
        setAdditionalInfoOptions([]);
      }
    } catch (error) {
      console.error('Failed to fetch family heads:', error);
      message.error('Failed to fetch family heads. Please try again later.');
    }
  }, [vakairaMap, subVakairaMap]);

  useEffect(() => {
    fetchData();
    fetchDataVakaira();
  }, []);

  useEffect(() => {
    if (selectedVakaira) {
      fetchDataSubVakaira(selectedVakaira);
    } else {
      setSubVakairaOptions([]);
    }
  }, [selectedVakaira]);

  useEffect(() => {
    if (familyType === 'FamilyMember' && selectedVakaira && selectedSubVakaira) {
      fetchFamilyHeads(selectedVakaira, selectedSubVakaira);
    } else {
      setAdditionalInfoOptions([]);
    }
  }, [familyType, selectedVakaira, selectedSubVakaira, fetchFamilyHeads]);
  
  

  const fetchData = async () => {
    try {
      const response = await otherApi.get('/member/female');
      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data);
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('Failed to fetch data:', error);
      message.error('Failed to fetch data. Please try again later.');
    }
  };

  const fetchDataVakaira = async () => {
    try {
      const response = await otherApi.get('/vakaira');
      if (response.data && Array.isArray(response.data.data)) {
        const vakairaMap = new Map();
        response.data.data.forEach(v => {
          vakairaMap.set(v._id, v.vakairaName || 'Unknown');
        });
        setVakairaOptions(response.data.data.map(v => ({
          value: v._id,
          label: v.vakairaName || 'Unknown'
        })));
        setVakairaMap(vakairaMap);
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('Failed to fetch Vakaira data:', error);
      message.error('Failed to fetch Vakaira data. Please try again later.');
    }
  };

  const fetchDataSubVakaira = async (vakairaId) => {
    try {
      const response = await otherApi.get(`/vakaira/${vakairaId}`);
      if (response.data && response.data.success && response.data.data && Array.isArray(response.data.data.subVakairaName)) {
        const subVakairaMap = new Map();
        response.data.data.subVakairaName.forEach(sv => {
          subVakairaMap.set(sv._id, sv.subVakairaName || 'Unknown');
        });
        setSubVakairaOptions(response.data.data.subVakairaName.map(sv => ({
          value: sv._id,
          label: sv.subVakairaName || 'Unknown'
        })));
        setSubVakairaMap(subVakairaMap);
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('Failed to fetch Sub-Vakaira data:', error);
      message.error('Failed to fetch Sub-Vakaira data. Please try again later.');
    }
  };

  
  
  
  const convertIdsToNames = (values) => {
    const vakairaName = vakairaMap.get(values.vakairaName) || 'Unknown Vakaira';
    const subVakairaName = subVakairaMap.get(values.subVakairaName) || 'Unknown Sub-Vakaira';
    return {
      vakairaName,
      subVakairaName
      
    };
  };

  const handleAdd = async (values) => {
    try {
      // Convert IDs to names
      const { vakairaName, subVakairaName } = convertIdsToNames(values);
      
      // Prepare the request body
      const requestBody = {
        vakairaName,
        subVakairaName,
        familyType: values.familyType,
        memberName: values.memberName,
        familyhead: values.familyhead,
        memberAddress: values.memberAddress || '',
        memberPhone: values.memberPhone,
        fatherName: values.fatherName,
        email: values.email,
        address: values.address || '',
        occupation: values.occupation,
        city_1: values.city_1,
        city_2: values.city_2,
        village_1: values.village_1,
        village_2: values.village_2,
        state: values.state,
        country: values.country
      };
  
      console.log('Request Body:', requestBody); // Log the request body
  
      // Make the POST request
      const response = await otherApi.post('/member/addfemaleMember', requestBody);
      console.log('Response:', response.data); // Log the response
  
      // Handle successful response
      message.success('Member added successfully');
      fetchData();
      form.resetFields();
      setIsModalVisible(false);
  
    } catch (error) {
      console.error('Failed to add member:', error.response ? error.response.data : error.message);
      message.error('Failed to add member. Please try again later.');
    }
  };
  
  const handleUpdate = async (values) => {
    try {
      const apiEndpoint = `/member/updateotherMember/${currentRecord._id}`;
      await otherApi.put(apiEndpoint, {
        vakairaName: values.vakairaName,
        subVakairaName: values.subVakairaName,
        familyType: values.familyType,
        memberName: values.memberName,
        memberAddress: values.memberAddress,
        memberPhone: values.memberPhone,
        fatherName: values.fatherName,
        email: values.email,
        address: values.address,
        occupation: values.occupation,
      });
      message.success('Member updated successfully');
      fetchData();
      form.resetFields();
      setIsModalVisible(false);
    } catch (error) {
      console.error('Failed to update data:', error.response ? error.response.data : error.message);
      message.error('Failed to update data. Please try again later.');
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editMode) {
        await handleUpdate(values);
      } else {
        await handleAdd(values);
      }
      fetchData();
      form.resetFields();
      setIsModalVisible(false);
    } catch (error) {
      console.error('Failed to submit data:', error.response ? error.response.data : error.message);
      message.error('Failed to submit data. Please try again later.');
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleAddMemberClick = () => {
    setEditMode(false);
    setCurrentRecord(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    form.setFieldsValue({
      ...record,
      vakairaName: record.vakairaId,
      subVakairaName: record.subVakairaId,
    });
    setEditMode(true);
    setCurrentRecord(record);
    setSelectedVakaira(record.vakairaId);
    setFamilyType(record.familyType);
    if (record.familyType === 'FamilyMember') {
      fetchFamilyHeads(record.vakairaId, record.subVakairaId);
    }
    setIsModalVisible(true);
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this record?',
      onOk: async () => {
        try {
          await otherApi.delete(`/member/deletefemaleMember/${id}`);
          setData(data.filter(item => item._id !== id));
          message.success('Member deleted successfully');
        } catch (error) {
          console.error('Failed to delete member:', error.response ? error.response.data : error.message);
          message.error('Failed to delete member. Please try again later.');
        }
      },
    });
  };

  const handleSearch = () => {
    const filteredData = data.filter(item => item.memberName.toLowerCase().includes(searchText.toLowerCase()));
    setData(filteredData);
  };

  const columns = [
    {
      title: 'Member Name',
      dataIndex: 'memberName',
      key: 'memberName',
    },
    {
      title: 'Vakaira',
      dataIndex: 'vakairaName',
      key: 'vakairaName',
    },
    {
      title: 'Sub-Vakaira',
      dataIndex: 'subVakairaName',
      key: 'subVakairaName',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Button icon={<DeleteOutlined />} onClick={() => handleDelete(record._id)} />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Input.Search
            placeholder="Search by member name"
            onSearch={handleSearch}
            onChange={(e) => setSearchText(e.target.value)}
            enterButton
          />
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddMemberClick}
          >
            Add Member
          </Button>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="_id"
        pagination={{ pageSize: 10 }}
      />
      <Modal
        title={editMode ? 'Edit Member' : 'Add Member'}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={editMode ? 'Update' : 'Add'}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ familyType: 'FamilyMember' }}
        >
          <Form.Item
            name="memberName"
            label="Member Name"
            rules={[{ required: true, message: 'Please enter member name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="vakairaName"
            label="Vakaira"
            rules={[{ required: true, message: 'Please select Vakaira!' }]}
          >
            <Select
              options={vakairaOptions}
              onChange={(value) => setSelectedVakaira(value)}
            />
          </Form.Item>
          <Form.Item
  name="subVakairaName"
  label="Sub-Vakaira"
  rules={[{ required: true, message: 'Please select Sub-Vakaira!' }]}
>
  <Select 
    options={subVakairaOptions} 
    onChange={(value) => setSelectedSubVakaira(value)} 
  />
</Form.Item>

          <Form.Item
            name="familyType"
            label="Family Type"
            rules={[{ required: true, message: 'Please select family type!' }]}
          >
            <Select onChange={(value) => setFamilyType(value)}>
              <Select.Option value="FamilyHead">Family Head</Select.Option>
              <Select.Option value="FamilyMember">Family Member</Select.Option>
            </Select>
          </Form.Item>
          {familyType === 'FamilyMember' && (
            <Form.Item
              name="familyhead"
              label="Family Head"
              rules={[{ required: familyType === 'FamilyMember', message: 'Please select family head!' }]}
            >
              <Select options={additionalInfoOptions} />
            </Form.Item>
          )}
          <Form.Item
            name="address"
            label="Address"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            name="memberAddress"
            label="MemberAddress"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            name="memberPhone"
            label="Phone"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="fatherName"
            label="Father's Name"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="occupation"
            label="Occupation"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="city_1"
            label="City 1"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="city_2"
            label="City 2"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="village_1"
            label="Village 1"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="village_2"
            label="Village 2"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="state"
            label="State"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="country"
            label="Country"
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Member;
